import CoAutocomplete from "./CoAutocomplete";
import { Action } from "./CoState";
import { Filter } from "./CoQuery";
import { MenuItem, Select } from "@mui/material";
import { make as UnitImageExtended } from "common/src/tft-static/UnitImageExtended.bs";
import { common as t } from "common/src/bindings/Translation2";
import * as Sd from "common/src/tft-static/Sd";
import { use as useSet } from "common/src/data/TftSet.bs";
import * as T from "common/src/bindings/Translation2";

type FilterSelectProps = {
  value: Filter | undefined;
  options: Array<Filter>;
  dispatch: (a: Action) => void;
  getMatches: (search: string) => Array<Filter>;
  idx: number;
  disabled?: boolean;
  allFilters: Array<Filter>;
  exclude?: boolean;
};

const FilterSelect = ({
  value,
  options,
  dispatch,
  getMatches,
  idx,
  disabled,
  allFilters,
  exclude,
}: FilterSelectProps) => {
  const set = useSet();
  const setFilter = exclude ? "set_exclude_filter" : "set_filter";

  return (
    <div>
      <div className="flex">
        <CoAutocomplete
          inputId={`co-${exclude ? "exclude-" : ""}filter-${idx}`}
          disabled={disabled}
          placeholder={`${t("Filter")} #${idx + 1}`}
          value={value}
          options={options}
          onChange={(v) => {
            dispatch([setFilter, [idx, v]]);
            if (v) {
              setTimeout(() => {
                const el: any = document.getElementsByClassName(
                  `co-${exclude ? "exclude-" : ""}filter-${idx + 1}`,
                )[0];
                el?.focus();
              }, 0);
            }
          }}
          getMatches={getMatches}
        />
      </div>
      {(() => {
        if (!value) {
          return null;
        } else if (exclude) {
          switch (value.typ) {
            case "u":
              return (
                <div className="flex text-[13px]">
                  <div className="flex items-center gap-[6px] pl-2 pt-2">
                    <div>{t("Star Level")}</div>
                    <Select
                      value={value.starLevel}
                      label="Star Level"
                      onChange={(e) =>
                        dispatch([
                          setFilter,
                          [
                            idx,
                            { ...value, starLevel: Number(e.target.value) },
                          ],
                        ])
                      }
                      variant="standard"
                      sx={{ width: 46 }}
                      classes={{
                        select: "!pr-[18px] py-[3px] text-[13px]",
                        icon: "my-[2px] w-[20px] h-[20px]",
                      }}
                    >
                      <MenuItem value={0}>{T.common("Any")}</MenuItem>
                      <MenuItem value={1}>1★</MenuItem>
                      <MenuItem value={2}>2★</MenuItem>
                      <MenuItem value={3}>3★</MenuItem>
                      <MenuItem value={4}>4★</MenuItem>
                    </Select>
                  </div>
                  {/* <div className="flex items-center gap-[6px] pl-3 pt-2">
                    <div>{t("Item Count")}</div>
                    <Select
                      value={value.itemCount == null ? "_" : value.itemCount}
                      label="Item Count"
                      onChange={(e) => {
                        const v = String(e.target.value);
                        dispatch([
                          setFilter,
                          [
                            idx,
                            { ...value, itemCount: v === "_" ? undefined : v },
                          ],
                        ]);
                      }}
                      variant="standard"
                      sx={{ width: 46 }}
                      classes={{
                        select: "!pr-[18px] py-[3px] text-[13px]",
                        icon: "my-[2px] w-[20px] h-[20px]",
                      }}
                    >
                      <MenuItem value="_">Any</MenuItem>
                      <MenuItem value="0">0</MenuItem>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="+1">1+</MenuItem>
                      <MenuItem value="-1">1-</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="+2">2+</MenuItem>
                      <MenuItem value="-2">2-</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                    </Select>
                  </div> */}
                </div>
              );
            case "i":
              const selected = allFilters.findIndex(
                (f) =>
                  f.typ === "u" &&
                  value.unitId?.[0] === f.id &&
                  value.unitId?.[1] === f.starLevel,
              );
              return (
                <div className="flex items-center gap-3 pl-3 pt-2 text-sm">
                  <div>{t("User")}</div>
                  <Select
                    classes={{
                      select:
                        "w-[125px] flex items-center gap-[6px] !pr-[18px] py-[3px] text-[14px]",
                      icon: "my-[2px] w-[20px] h-[20px]",
                    }}
                    labelId={`ex-a-aug-pick-${idx}`}
                    value={selected}
                    label={T.common("User")}
                    onChange={(e) => {
                      const pickIdx = Number(e.target.value);
                      const pick = allFilters[pickIdx];
                      if (pick?.typ === "u") {
                        dispatch([
                          setFilter,
                          [
                            idx,
                            { ...value, unitId: [pick.id, pick.starLevel] },
                          ],
                        ]);
                      } else {
                        dispatch([
                          setFilter,
                          [idx, { ...value, unitId: undefined }],
                        ]);
                      }
                    }}
                    variant="standard"
                  >
                    <MenuItem
                      key={idx}
                      value={-1}
                      className="flex gap-[6px] items-center"
                    >
                      {t("Any")}
                    </MenuItem>
                    {allFilters.map((filter: Filter, idx) => {
                      if (filter.typ === "u") {
                        return (
                          <MenuItem
                            key={idx}
                            value={idx}
                            className="flex gap-[6px] items-center"
                          >
                            <UnitImageExtended
                              starLevel={
                                filter.starLevel !== 0
                                  ? filter.starLevel
                                  : undefined
                              }
                              forceStarLevel={filter.starLevel !== 0}
                              unitId={filter.id}
                              items={[]}
                              size={20}
                              showName={false}
                            />
                            {filter.label}
                          </MenuItem>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </Select>
                </div>
              );
            default:
              return null;
          }
        } else {
          switch (value.typ) {
            case "u":
              return (
                <div className="flex text-[13px]">
                  <div className="flex items-center gap-[6px] pl-2 pt-2">
                    <div>{t("Star Level")}</div>
                    <Select
                      value={value.starLevel}
                      label="Star Level"
                      onChange={(e) =>
                        dispatch([
                          setFilter,
                          [
                            idx,
                            { ...value, starLevel: Number(e.target.value) },
                          ],
                        ])
                      }
                      variant="standard"
                      sx={{ width: 46 }}
                      classes={{
                        select: "!pr-[18px] py-[3px] text-[13px]",
                        icon: "my-[2px] w-[20px] h-[20px]",
                      }}
                    >
                      <MenuItem value={0}>{T.common("Any")}</MenuItem>
                      <MenuItem value={1}>1★</MenuItem>
                      <MenuItem value={2}>2★</MenuItem>
                      <MenuItem value={3}>3★</MenuItem>
                      <MenuItem value={4}>4★</MenuItem>
                    </Select>
                  </div>
                  <div className="flex items-center gap-[6px] pl-3 pt-2">
                    <div>{t("Item Count Filter")}</div>
                    <Select
                      value={value.itemCount == null ? "_" : value.itemCount}
                      label="Item Count"
                      onChange={(e) => {
                        const v = String(e.target.value);
                        dispatch([
                          setFilter,
                          [
                            idx,
                            { ...value, itemCount: v === "_" ? undefined : v },
                          ],
                        ]);
                      }}
                      variant="standard"
                      sx={{ width: 46 }}
                      classes={{
                        select: "!pr-[18px] py-[3px] text-[13px]",
                        icon: "my-[2px] w-[20px] h-[20px]",
                      }}
                    >
                      <MenuItem value="_">{T.common("Any")}</MenuItem>
                      <MenuItem value="0">0</MenuItem>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="+1">1+</MenuItem>
                      <MenuItem value="-1">1-</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="+2">2+</MenuItem>
                      <MenuItem value="-2">2-</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                    </Select>
                  </div>
                </div>
              );
            case "t":
              const baseRank = value.rank.replace(/\+|-/, "");
              return (
                <div className="flex items-center gap-3 pl-3 pt-2 text-sm">
                  <div>{T.common("Trait Tier")}</div>
                  <Select
                    labelId={`ex-t-rank-pick-${idx}`}
                    value={value.rank}
                    label={T.common("Trait Tier")}
                    onChange={(e) =>
                      dispatch([
                        setFilter,
                        [idx, { ...value, rank: String(e.target.value) }],
                      ])
                    }
                    variant="standard"
                    sx={{ width: 46 }}
                    classes={{
                      select: "!pr-[18px] py-[3px] text-[14px]",
                      icon: "my-[2px] w-[20px] h-[20px]",
                    }}
                  >
                    <MenuItem value={baseRank}>{baseRank}</MenuItem>
                    <MenuItem value={"+" + baseRank}>{baseRank + "+"}</MenuItem>
                    <MenuItem value={"-" + baseRank}>{baseRank + "-"}</MenuItem>
                  </Select>
                </div>
              );
            case "i":
              const selected = allFilters.findIndex(
                (f) =>
                  f.typ === "u" &&
                  value.unitId?.[0] === f.id &&
                  value.unitId?.[1] === f.starLevel,
              );
              return (
                <div className="flex items-center gap-3 pl-3 pt-2 text-sm">
                  <div>{t("User")}</div>
                  <Select
                    classes={{
                      select:
                        "w-[125px] flex items-center gap-[6px] !pr-[18px] py-[3px] text-[14px]",
                      icon: "my-[2px] w-[20px] h-[20px]",
                    }}
                    labelId={`ex-a-aug-pick-${idx}`}
                    value={selected}
                    label={t("User")}
                    onChange={(e) => {
                      const pickIdx = Number(e.target.value);
                      const pick = allFilters[pickIdx];
                      if (pick?.typ === "u") {
                        dispatch([
                          setFilter,
                          [
                            idx,
                            { ...value, unitId: [pick.id, pick.starLevel] },
                          ],
                        ]);
                      } else {
                        dispatch([
                          setFilter,
                          [idx, { ...value, unitId: undefined }],
                        ]);
                      }
                    }}
                    variant="standard"
                  >
                    <MenuItem
                      key={idx}
                      value={-1}
                      className="flex gap-[6px] items-center"
                    >
                      {T.common("Any")}
                    </MenuItem>
                    {allFilters.map((filter: Filter, idx) => {
                      if (filter.typ === "u") {
                        return (
                          <MenuItem
                            key={idx}
                            value={idx}
                            className="flex gap-[6px] items-center"
                          >
                            <UnitImageExtended
                              starLevel={
                                filter.starLevel !== 0
                                  ? filter.starLevel
                                  : undefined
                              }
                              forceStarLevel={filter.starLevel !== 0}
                              unitId={filter.id}
                              items={[]}
                              size={20}
                              showName={false}
                            />
                            {filter.label}
                          </MenuItem>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </Select>
                </div>
              );
            case "a":
              return (
                <div className="flex items-center gap-3 pl-3 pt-2 text-sm">
                  <div>{t("Pick")}</div>
                  <Select
                    labelId={`ex-a-aug-pick-${idx}`}
                    value={value.pick}
                    label="Pick"
                    onChange={(e) =>
                      dispatch([
                        setFilter,
                        [idx, { ...value, pick: Number(e.target.value) }],
                      ])
                    }
                    variant="standard"
                    sx={{ width: 52 }}
                    classes={{
                      select: "!pr-[18px] py-[3px] text-[14px]",
                      icon: "my-[2px] w-[20px] h-[20px]",
                    }}
                  >
                    <MenuItem value={0}>{T.common("Any")}</MenuItem>
                    <MenuItem value={1}>2-1</MenuItem>
                    <MenuItem value={2}>3-2</MenuItem>
                    <MenuItem value={3}>4-2</MenuItem>
                  </Select>
                </div>
              );
            default:
              return <div className="h-10" />;
          }
        }
      })()}
    </div>
  );
};

export default FilterSelect;
